module.exports = __webpack_public_path__ + "static/img/yxblogo.6a3c8b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yxblogo.png
// module id = tagK
// module chunks = 1